
// frontend/src/components/Header.tsx
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Settings } from "lucide-react";
import { useAuth } from "../context/use-auth";
import IconButton from "@/components/ui/IconButton";

export default function Header() {
  const { isLoggedIn, logout } = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  return (
    <header className="fixed top-0 left-0 w-full bg-white shadow h-12 flex items-center justify-between px-4 z-50">
      <div className="flex items-center gap-8">
        <div className="text-lg text-elani-blue leading-none select-none">
          <span className="font-bold">ELANI</span>
          <span className="font-bold text-elani-orange ml-1">.</span>
          <span className="font-normal">Energy</span>
          <sup className="align-super text-[10px] font-medium ml-1 text-elani-orange" aria-label={t("brand.beta")}>{t("brand.beta")}</sup>
        </div>
        {isLoggedIn && (
          <Link to="/dashboard" className="text-sm text-gray-700 hover:text-elani-blue">
            {t("nav.dashboard")}
          </Link>
        )}
      </div>
      <div className="flex items-center gap-4 text-xs">
        {isLoggedIn && (
          <IconButton
            to="/settings"
            label={t("nav.settings")}
            icon={<Settings className="h-5 w-5" />}
          />
        )}
        {isLoggedIn ? (
          <button
            onClick={handleLogout}
            className="bg-elani-blue text-white px-3 py-1 rounded"
          >
            {t("nav.logout")}
          </button>
        ) : (
          <Link
            to="/login"
            className="bg-elani-blue text-white px-3 py-1 rounded"
          >
            {t("nav.login")}
          </Link>
        )}
      </div>
    </header>
  );
}
